import { render } from "./Child.vue?vue&type=template&id=6b3e3d90&scoped=true"
import script from "./Child.vue?vue&type=script&lang=js"
export * from "./Child.vue?vue&type=script&lang=js"

import "./Child.vue?vue&type=style&index=0&id=6b3e3d90&scoped=true&lang=css"

import exportComponent from "D:\\Git\\Tepparad\\Tepparad-benefit-newver\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3e3d90"]])

export default __exports__